import { supabase } from './supabase';

export interface AuditLogEntry {
  id: string;
  actor_user_id: string | null;
  actor_email: string | null;
  action: string;
  target_type: string | null;
  target_id: string | null;
  metadata: Record<string, unknown> | null;
  created_at: string;
}

// Best-effort: fire and forget. RLS will silently drop the insert for
// non-admins, which is fine — we never want a logging failure to break
// the actual admin action. Returns void deliberately.
export async function logAdminAction(
  action: string,
  opts: { targetType?: string; targetId?: string; metadata?: Record<string, unknown> } = {},
): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    await supabase.from('admin_audit_log').insert({
      actor_user_id: user.id,
      actor_email: user.email,
      action,
      target_type: opts.targetType || null,
      target_id: opts.targetId || null,
      metadata: opts.metadata || null,
    });
  } catch {
    // swallow — logging must never throw
  }
}

export async function fetchAuditLog(limit = 200): Promise<AuditLogEntry[]> {
  const { data, error } = await supabase
    .from('admin_audit_log')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit);
  if (error) return [];
  return (data || []) as AuditLogEntry[];
}
